"use client";

import { useState } from "react";
import DemoFooter from "@/components/preview/demo-footer";
import SliderControl from "@/components/preview/slider-control";

const MIN_RADIUS = 0;
const MAX_RADIUS = 32;
const PADDING = 8;
const INITIAL_RADIUS = 16;

export function InteractiveDemos() {
  const [radius, setRadius] = useState(INITIAL_RADIUS);

  return (
    <div className="flex h-full w-full flex-col items-center justify-center overflow-hidden bg-preview-bg">
      <div className="flex flex-1 items-center justify-center">
        <div
          className="flex items-center justify-center border border-gray-400 bg-preview-bg"
          style={{
            borderRadius: `${radius + PADDING}px`,
            padding: `${PADDING}px`,
          }}
        >
          <div
            className="size-16 border border-gray-400 bg-gray-300"
            style={{ borderRadius: `${radius}px` }}
          />
        </div>
      </div>
      <DemoFooter className="flex-col items-stretch gap-2 px-3 py-2">
        <SliderControl
          className="mb-1"
          label="Border Radius"
          max={MAX_RADIUS}
          min={MIN_RADIUS}
          onChange={setRadius}
          step={1}
          value={radius}
          valueLabel={`${radius}px`}
        />
      </DemoFooter>
    </div>
  );
}
